<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="机构名称" prop="tenantFullName">
            <el-input v-model="queryParams.tenantFullName" placeholder="请输入公司名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="机构类型" prop="tenantType">
            <el-select
              v-model="queryParams.tenantType"
              placeholder="请选择类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in typeOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="跟进状态" prop="followFlag">
            <el-select
              v-model="queryParams.followFlag"
              placeholder="请选择跟进状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="followFlag in followOptions"
                :key="followFlag.code"
                :label="followFlag.name"
                :value="followFlag.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item :gutter="40">
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="用户昵称" align="center" prop="applyUserNickName" />
      <el-table-column label="机构名称" align="center" prop="tenantFullName" />
      <el-table-column label="机构类型" align="center" prop="tenantDesc" />
      <el-table-column label="联系人" align="center" prop="linkNickName" />
      <el-table-column label="手机号" align="center" prop="linkTel" />
      <el-table-column label="申请时间" min-width="140" align="center" prop="createTime" />
      <el-table-column label="跟进状态" align="center" prop="followFlagName" />
      <el-table-column label="跟进描述" align="center" prop="followDescription" show-overflow-tooltip/>
      <el-table-column label="操作" min-width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">修改跟进状态</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <ApplyDialog ref="applyDialog" @success="getList"></ApplyDialog>
  </div>

</template>


<script>
import { queryApplyList } from "@/api/system/tenant";
import ApplyDialog from "./components/applyDialog";

export default {
  name: "BusinessList",
  components: {
    ApplyDialog
  },
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      data: {
        startDate: "",
        endDate: ""
      },
      typeOptions: [{
        code: '1',
        name: '企业'
      },{
        code: '2',
        name: '组织'
      },{
        code: '3',
        name: '专家'
      },],
      followOptions:[
        {
          code: '1',
          name: '未跟进',
          value:'0'
        },{
          code: '2',
          name: '已跟进',
          value:'1'
        }
      ],
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        tenantFullName: null,
        tenantType: null
      },
      dataList: []
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    getList() {
      this.queryParams.pageNum = 1;
      this.queryList();
    },
    handleEdit(row) {
      this.$refs.applyDialog.open(JSON.parse(JSON.stringify(row)));
    },
    queryList() {
      this.loading = true;
      queryApplyList(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },
  }
};
</script>


